// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/DappModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { PagingInfo } from "./SystemModels";

export const protobufPackage = "daisi.protos.v1";

export enum DappTypes {
  DappConsumer = 0,
  DappTool = 1,
  UNRECOGNIZED = -1,
}

export function dappTypesFromJSON(object: any): DappTypes {
  switch (object) {
    case 0:
    case "DappConsumer":
      return DappTypes.DappConsumer;
    case 1:
    case "DappTool":
      return DappTypes.DappTool;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DappTypes.UNRECOGNIZED;
  }
}

export function dappTypesToJSON(object: DappTypes): string {
  switch (object) {
    case DappTypes.DappConsumer:
      return "DappConsumer";
    case DappTypes.DappTool:
      return "DappTool";
    case DappTypes.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetDappRequest {
  DappId?: string | undefined;
  Paging?: PagingInfo | undefined;
}

export interface GetDappResponse {
  Dapps: Dapp[];
  TotalCount: number;
}

export interface ResetDappRequest {
  DappId: string;
}

export interface ResetDappResponse {
  SecretKey: string;
}

export interface GetDappSecretKeyRequest {
  DappId: string;
}

export interface GetDappSecretKeyResponse {
  SecretKey: string;
}

export interface CreateDappRequest {
  Name: string;
  Type: DappTypes;
}

export interface CreateDappResponse {
  Dapp?: Dapp | undefined;
}

export interface UpdateDappRequest {
  Dapp?: Dapp | undefined;
}

export interface UpdateDappResponse {
  Success: boolean;
  Message: string;
}

export interface DeleteDappRequest {
  DappId: string;
}

export interface DeleteDappResponse {
  Success: boolean;
  Message: string;
}

export interface Dapp {
  Id: string;
  Name: string;
  Type: DappTypes;
  AccountId: string;
  AccountName: string;
  DateApproved?: Date | undefined;
}

function createBaseGetDappRequest(): GetDappRequest {
  return { DappId: undefined, Paging: undefined };
}

export const GetDappRequest: MessageFns<GetDappRequest> = {
  encode(message: GetDappRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DappId !== undefined) {
      writer.uint32(10).string(message.DappId);
    }
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDappRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDappRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DappId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDappRequest {
    return {
      DappId: isSet(object.DappId) ? globalThis.String(object.DappId) : undefined,
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
    };
  },

  toJSON(message: GetDappRequest): unknown {
    const obj: any = {};
    if (message.DappId !== undefined) {
      obj.DappId = message.DappId;
    }
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDappRequest>, I>>(base?: I): GetDappRequest {
    return GetDappRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDappRequest>, I>>(object: I): GetDappRequest {
    const message = createBaseGetDappRequest();
    message.DappId = object.DappId ?? undefined;
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseGetDappResponse(): GetDappResponse {
  return { Dapps: [], TotalCount: 0 };
}

export const GetDappResponse: MessageFns<GetDappResponse> = {
  encode(message: GetDappResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Dapps) {
      Dapp.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDappResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDappResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Dapps.push(Dapp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDappResponse {
    return {
      Dapps: globalThis.Array.isArray(object?.Dapps) ? object.Dapps.map((e: any) => Dapp.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetDappResponse): unknown {
    const obj: any = {};
    if (message.Dapps?.length) {
      obj.Dapps = message.Dapps.map((e) => Dapp.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDappResponse>, I>>(base?: I): GetDappResponse {
    return GetDappResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDappResponse>, I>>(object: I): GetDappResponse {
    const message = createBaseGetDappResponse();
    message.Dapps = object.Dapps?.map((e) => Dapp.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseResetDappRequest(): ResetDappRequest {
  return { DappId: "" };
}

export const ResetDappRequest: MessageFns<ResetDappRequest> = {
  encode(message: ResetDappRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DappId !== "") {
      writer.uint32(10).string(message.DappId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResetDappRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResetDappRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DappId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResetDappRequest {
    return { DappId: isSet(object.DappId) ? globalThis.String(object.DappId) : "" };
  },

  toJSON(message: ResetDappRequest): unknown {
    const obj: any = {};
    if (message.DappId !== "") {
      obj.DappId = message.DappId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResetDappRequest>, I>>(base?: I): ResetDappRequest {
    return ResetDappRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResetDappRequest>, I>>(object: I): ResetDappRequest {
    const message = createBaseResetDappRequest();
    message.DappId = object.DappId ?? "";
    return message;
  },
};

function createBaseResetDappResponse(): ResetDappResponse {
  return { SecretKey: "" };
}

export const ResetDappResponse: MessageFns<ResetDappResponse> = {
  encode(message: ResetDappResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResetDappResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResetDappResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResetDappResponse {
    return { SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "" };
  },

  toJSON(message: ResetDappResponse): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResetDappResponse>, I>>(base?: I): ResetDappResponse {
    return ResetDappResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResetDappResponse>, I>>(object: I): ResetDappResponse {
    const message = createBaseResetDappResponse();
    message.SecretKey = object.SecretKey ?? "";
    return message;
  },
};

function createBaseGetDappSecretKeyRequest(): GetDappSecretKeyRequest {
  return { DappId: "" };
}

export const GetDappSecretKeyRequest: MessageFns<GetDappSecretKeyRequest> = {
  encode(message: GetDappSecretKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DappId !== "") {
      writer.uint32(10).string(message.DappId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDappSecretKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDappSecretKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DappId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDappSecretKeyRequest {
    return { DappId: isSet(object.DappId) ? globalThis.String(object.DappId) : "" };
  },

  toJSON(message: GetDappSecretKeyRequest): unknown {
    const obj: any = {};
    if (message.DappId !== "") {
      obj.DappId = message.DappId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDappSecretKeyRequest>, I>>(base?: I): GetDappSecretKeyRequest {
    return GetDappSecretKeyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDappSecretKeyRequest>, I>>(object: I): GetDappSecretKeyRequest {
    const message = createBaseGetDappSecretKeyRequest();
    message.DappId = object.DappId ?? "";
    return message;
  },
};

function createBaseGetDappSecretKeyResponse(): GetDappSecretKeyResponse {
  return { SecretKey: "" };
}

export const GetDappSecretKeyResponse: MessageFns<GetDappSecretKeyResponse> = {
  encode(message: GetDappSecretKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDappSecretKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDappSecretKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDappSecretKeyResponse {
    return { SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "" };
  },

  toJSON(message: GetDappSecretKeyResponse): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDappSecretKeyResponse>, I>>(base?: I): GetDappSecretKeyResponse {
    return GetDappSecretKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDappSecretKeyResponse>, I>>(object: I): GetDappSecretKeyResponse {
    const message = createBaseGetDappSecretKeyResponse();
    message.SecretKey = object.SecretKey ?? "";
    return message;
  },
};

function createBaseCreateDappRequest(): CreateDappRequest {
  return { Name: "", Type: 0 };
}

export const CreateDappRequest: MessageFns<CreateDappRequest> = {
  encode(message: CreateDappRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.Type !== 0) {
      writer.uint32(16).int32(message.Type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateDappRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDappRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDappRequest {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Type: isSet(object.Type) ? dappTypesFromJSON(object.Type) : 0,
    };
  },

  toJSON(message: CreateDappRequest): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Type !== 0) {
      obj.Type = dappTypesToJSON(message.Type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDappRequest>, I>>(base?: I): CreateDappRequest {
    return CreateDappRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDappRequest>, I>>(object: I): CreateDappRequest {
    const message = createBaseCreateDappRequest();
    message.Name = object.Name ?? "";
    message.Type = object.Type ?? 0;
    return message;
  },
};

function createBaseCreateDappResponse(): CreateDappResponse {
  return { Dapp: undefined };
}

export const CreateDappResponse: MessageFns<CreateDappResponse> = {
  encode(message: CreateDappResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Dapp !== undefined) {
      Dapp.encode(message.Dapp, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateDappResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDappResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Dapp = Dapp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDappResponse {
    return { Dapp: isSet(object.Dapp) ? Dapp.fromJSON(object.Dapp) : undefined };
  },

  toJSON(message: CreateDappResponse): unknown {
    const obj: any = {};
    if (message.Dapp !== undefined) {
      obj.Dapp = Dapp.toJSON(message.Dapp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDappResponse>, I>>(base?: I): CreateDappResponse {
    return CreateDappResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDappResponse>, I>>(object: I): CreateDappResponse {
    const message = createBaseCreateDappResponse();
    message.Dapp = (object.Dapp !== undefined && object.Dapp !== null) ? Dapp.fromPartial(object.Dapp) : undefined;
    return message;
  },
};

function createBaseUpdateDappRequest(): UpdateDappRequest {
  return { Dapp: undefined };
}

export const UpdateDappRequest: MessageFns<UpdateDappRequest> = {
  encode(message: UpdateDappRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Dapp !== undefined) {
      Dapp.encode(message.Dapp, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateDappRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDappRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Dapp = Dapp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDappRequest {
    return { Dapp: isSet(object.Dapp) ? Dapp.fromJSON(object.Dapp) : undefined };
  },

  toJSON(message: UpdateDappRequest): unknown {
    const obj: any = {};
    if (message.Dapp !== undefined) {
      obj.Dapp = Dapp.toJSON(message.Dapp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDappRequest>, I>>(base?: I): UpdateDappRequest {
    return UpdateDappRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDappRequest>, I>>(object: I): UpdateDappRequest {
    const message = createBaseUpdateDappRequest();
    message.Dapp = (object.Dapp !== undefined && object.Dapp !== null) ? Dapp.fromPartial(object.Dapp) : undefined;
    return message;
  },
};

function createBaseUpdateDappResponse(): UpdateDappResponse {
  return { Success: false, Message: "" };
}

export const UpdateDappResponse: MessageFns<UpdateDappResponse> = {
  encode(message: UpdateDappResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== "") {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateDappResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDappResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDappResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
    };
  },

  toJSON(message: UpdateDappResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDappResponse>, I>>(base?: I): UpdateDappResponse {
    return UpdateDappResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDappResponse>, I>>(object: I): UpdateDappResponse {
    const message = createBaseUpdateDappResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? "";
    return message;
  },
};

function createBaseDeleteDappRequest(): DeleteDappRequest {
  return { DappId: "" };
}

export const DeleteDappRequest: MessageFns<DeleteDappRequest> = {
  encode(message: DeleteDappRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DappId !== "") {
      writer.uint32(10).string(message.DappId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteDappRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteDappRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DappId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteDappRequest {
    return { DappId: isSet(object.DappId) ? globalThis.String(object.DappId) : "" };
  },

  toJSON(message: DeleteDappRequest): unknown {
    const obj: any = {};
    if (message.DappId !== "") {
      obj.DappId = message.DappId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteDappRequest>, I>>(base?: I): DeleteDappRequest {
    return DeleteDappRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteDappRequest>, I>>(object: I): DeleteDappRequest {
    const message = createBaseDeleteDappRequest();
    message.DappId = object.DappId ?? "";
    return message;
  },
};

function createBaseDeleteDappResponse(): DeleteDappResponse {
  return { Success: false, Message: "" };
}

export const DeleteDappResponse: MessageFns<DeleteDappResponse> = {
  encode(message: DeleteDappResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== "") {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteDappResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteDappResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteDappResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
    };
  },

  toJSON(message: DeleteDappResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteDappResponse>, I>>(base?: I): DeleteDappResponse {
    return DeleteDappResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteDappResponse>, I>>(object: I): DeleteDappResponse {
    const message = createBaseDeleteDappResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? "";
    return message;
  },
};

function createBaseDapp(): Dapp {
  return { Id: "", Name: "", Type: 0, AccountId: "", AccountName: "", DateApproved: undefined };
}

export const Dapp: MessageFns<Dapp> = {
  encode(message: Dapp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.Type !== 0) {
      writer.uint32(24).int32(message.Type);
    }
    if (message.AccountId !== "") {
      writer.uint32(34).string(message.AccountId);
    }
    if (message.AccountName !== "") {
      writer.uint32(42).string(message.AccountName);
    }
    if (message.DateApproved !== undefined) {
      Timestamp.encode(toTimestamp(message.DateApproved), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Dapp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDapp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.AccountName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.DateApproved = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Dapp {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Type: isSet(object.Type) ? dappTypesFromJSON(object.Type) : 0,
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      AccountName: isSet(object.AccountName) ? globalThis.String(object.AccountName) : "",
      DateApproved: isSet(object.DateApproved) ? fromJsonTimestamp(object.DateApproved) : undefined,
    };
  },

  toJSON(message: Dapp): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Type !== 0) {
      obj.Type = dappTypesToJSON(message.Type);
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.AccountName !== "") {
      obj.AccountName = message.AccountName;
    }
    if (message.DateApproved !== undefined) {
      obj.DateApproved = message.DateApproved.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Dapp>, I>>(base?: I): Dapp {
    return Dapp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Dapp>, I>>(object: I): Dapp {
    const message = createBaseDapp();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.Type = object.Type ?? 0;
    message.AccountId = object.AccountId ?? "";
    message.AccountName = object.AccountName ?? "";
    message.DateApproved = object.DateApproved ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
